import { ACTIONS as planetUIActions } from '@~/actions/planet-ui';

const initialState = null;

export default function defaultExport(state = initialState, { type, payload }) {
  if (type === planetUIActions.SET_PLANET_UI) {
    return payload;
  }

  return state;
}
